<template>
  <span class="animated-gradient-text">
    <slot></slot>
  </span>
</template>

<style scoped lang="scss">
.animated-gradient-text {
  display: inline-block;
  background: var(--font-gradient);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientShift 10s ease infinite;
  font-weight: inherit;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
